import React from 'react';
import {TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import { UfSelectProps } from './uf-select-props';
import { useStyles } from './uf-select-styles';
const UFs: UF[] = [
  { sigla: 'AC', estado: 'Acre' },
  { sigla: 'AL', estado: 'Alagoas' },
  { sigla: 'AP', estado: 'Amapá' },
  { sigla: 'AM', estado: 'Amazonas' },
  { sigla: 'BA', estado: 'Bahia' },
  { sigla: 'CE', estado: 'Ceará' },
  { sigla: 'DF', estado: 'Distrito Federal' },
  { sigla: 'ES', estado: 'Espírito Santo' },
  { sigla: 'GO', estado: 'Goías' },
  { sigla: 'MA', estado: 'Maranhão' },
  { sigla: 'MT', estado: 'Mato Grosso' },
  { sigla: 'MS', estado: 'Mato Grosso do Sul' },
  { sigla: 'MG', estado: 'Minas Gerais' },
  { sigla: 'PA', estado: 'Pará' },
  { sigla: 'PB', estado: 'Paraíba' },
  { sigla: 'PR', estado: 'Paraná' },
  { sigla: 'PE', estado: 'Pernambuco' },
  { sigla: 'PI', estado: 'Piauí' },
  { sigla: 'RJ', estado: 'Rio de Janeiro' },
  { sigla: 'RN', estado: 'Rio Grande do Norte' },
  { sigla: 'RS', estado: 'Rio Grande do Sul' },
  { sigla: 'RO', estado: 'Rondônia' },
  { sigla: 'RR', estado: 'Roraíma' },
  { sigla: 'SC', estado: 'Santa Catarina' },
  { sigla: 'SP', estado: 'São Paulo' },
  { sigla: 'SE', estado: 'Sergipe' },
  { sigla: 'TO', estado: 'Tocantins' },
];

export const UfSelect: React.FC<UfSelectProps> = ({ ufValue, onInputChange, ...outrasProps }) => {
  const classes = useStyles();

  return (
    <Autocomplete
      options={UFs}
      getOptionLabel={(option) => option.sigla}
      fullWidth
      inputValue={ufValue}
      onInputChange={onInputChange}
      value={UFs.find((x) => x.sigla === ufValue)}
      renderInput={(params) => <TextField {...outrasProps} {...params} />}
      classes={{ popper: classes.popper }}
    />
  );
};

export class UF {
  constructor(public sigla: string, public estado: string) {}
}
